<template>
  <div class='document-view'>

    <div
      v-if='files && files.length !== 1'
      :class="['document-view-btn', currentFileIndex === 0 ? 'document-view-btn-hidden' : '']"
      @click='previousFile'
    >
      <i class="fa fa-arrow-left"></i>
    </div>

    <iframe
      v-if="files && currentFile.mediaType !== 'image' && currentFile.mimeType !== 'application/xml'"
      :src="currentFile.src"
      frameborder="0"
      class='document-view-iframe'
    ></iframe>

    <pre v-if="files && currentFile.mimeType === 'application/xml'" class='xml'>
      {{ xmlContent }}
    </pre>

    <div
      v-if="files && currentFile.mediaType === 'image'"
      class="document-view-image-container"
    >

      <img
        ref='image'
        :src="currentFile.src"
        class='document-view-image'
        :style="{
          position: 'absolute',
          top: `${offsetY}px`,
          left: `${offsetX}px`,
          transform: `scale(${zoom}) rotate(${rotation}deg)`
        }"
      />

      <div class="document-view-panel-container">

        <div class="document-view-panel">

          <div class="document-view-panel-btn" @click='moveLeft'>
            <i class="fa fa-arrow-left"></i>
          </div>

          <div class="document-view-panel-btn" @click='moveRight'>
            <i class="fa fa-arrow-right"></i>
          </div>

          <div class="document-view-panel-btn" @click='moveUp'>
            <i class="fa fa-arrow-up"></i>
          </div>

          <div class="document-view-panel-btn" @click='moveDown'>
            <i class="fa fa-arrow-down"></i>
          </div>

          <div class="document-view-panel-btn" @click='rotateLeft'>
            <i class="fa fa-undo"></i>
          </div>

          <div class="document-view-panel-btn" @click='rotateRight'>
            <i class="fa fa-repeat"></i>
          </div>

          <div class="document-view-panel-btn" @click='zoomIn'>
            <i class="fa fa-search-plus"></i>
          </div>

          <div class="document-view-panel-btn" @click='zoomOut'>
            <i class="fa fa-search-minus"></i>
          </div>

        </div>

      </div>

    </div>

    <div
      v-if='files && files.length !== 1'
      :class="['document-view-btn', currentFileIndex === files.length - 1 ? 'document-view-btn-hidden' : '']"
      @click='nextFile'
    >
      <i class="fa fa-arrow-right"></i>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    baseUrl: {
      type: String,
      required: true
    },

    files: {
      type: Array
    }
  },

  data() {
    return {
      zoom: 1,
      offsetX: 0,
      offsetY: 0,
      rotation: 0,
      currentFileIndex: 0,
      xmlContent: ''
    }
  },

  computed: {
    currentFile() {
      return this.files[this.currentFileIndex]
    }
  },

  watch: {
    files() {
      this.currentFileIndex = 0
      this.resetView()

      if (this.files && this.currentFile.mimeType === 'application/xml') {
        this.showXml()
      }
    },

    currentFileIndex() {
      if (this.files && this.currentFile.mimeType === 'application/xml') {
        this.showXml()
      }
    }
  },

  methods: {
    resetView() {
      this.zoom = 1
      this.offsetX = 0
      this.offsetY = 0
    },

    nextFile() {
      this.resetView()
      if (this.currentFileIndex < this.files.length - 1) {
        this.currentFileIndex += 1
      }
    },

    previousFile() {
      this.resetView()
      if (this.currentFileIndex > 0) {
        this.currentFileIndex -= 1
      }
    },

    moveUp() {
      this.offsetY -= 50
    },

    moveDown() {
      this.offsetY += 50
    },

    moveLeft() {
      this.offsetX -= 50
    },

    moveRight() {
      this.offsetX += 50
    },

    zoomIn() {
      this.zoom += 0.1
    },

    zoomOut() {
      if (this.zoom > 0) {
        this.zoom -= 0.1
      }
    },

    rotateRight() {
      this.rotation += 90
    },

    rotateLeft() {
      this.rotation -= 90
    },

    async showXml() {
      const { data } = await axios.get(this.currentFile.src)

      this.xmlContent = data
    }
  }
}
</script>

<style>
.document-view{
  height: 100%;
  border: 2px dashed rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  overflow: hidden;
}

.document-view-iframe {
  flex: 1;
  height: 100%;
}

.document-view-image {
  user-select: none;
  z-index: -1;
}

.document-view-image-container {
  position: relative;
  flex: 1;
  height: 100%;
  overflow: hidden;
}

.document-view-btn {
  height: 100%;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.document-view-btn-hidden {
  visibility: hidden;
}

.document-view-btn:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.document-view-panel-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.document-view-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  padding: 8px;
  background-color: black;
  border-radius: 28px;
}

.document-view-panel-btn {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.document-view-panel-btn > i {
  transform: scale(1.5);
}

.document-view-panel-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.xml {
  max-width: 100%;
  height: 100%;
  overflow: auto;
  background-color: transparent !important;
  border: none !important;
}
</style>
